import React from "react";
import * as images from "../../assets/exportSkills";

const Skill = ({ skill: { id, description, src, experience } }) => {

  return (
    <div key={id} data-aos="fade-right">
      <span>
        <img src={images[description.toLowerCase()]} alt={src} />
      </span>
      <span>{description}</span>
      <p>{experience}</p>
    </div>
  );
};

export default Skill;
